import Page from "@/components/Page";
import PageContent from "@/components/PageContent";
import PageHeader from "@/components/PageHeader";
import PageTitle from "@/components/PageTitle";
import { Button } from "antd";
import { useUserStore } from "@/auth/stores/user";
import { useEffect } from "react";
import { ADMIN } from "@/auth/config/roles";
import { useNavigate } from "react-router-dom";
import { useGetUsers } from "@/user-control/api";
import Loading from "@/components/Loading";
import StaffTable from "@/time-tracking/components/StaffTable";

const Index = () => {
  const { user } = useUserStore();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect non-admin users to their own timesheet page
    if (user?.Role !== ADMIN) {
      navigate(`/time-tracking/timesheet/${user?.UserId}`, {
        replace: true,
      });
    }
  }, [user, navigate]);

  const { isLoading, data } = useGetUsers(
    {
      // Default to fetch first 500 users with Technician or Admin roles
      limit: 500,
      page: 1,
      search: [
        {
          column: "Role",
          operator: "IN",
          value: ["TECHNICIAN", "ADMIN"],
        },
        { column: "Status", value: ["Active"], operator: "IN" },
      ],
    },
    {
      // Only fetch if the user is an admin
      enabled: user?.Role === ADMIN,
    }
  );

  const handleTrackMyTimeClick = () => {
    navigate(`/time-tracking/timesheet/${user?.UserId}`);
  };

  if (user?.Role !== ADMIN) {
    return null;
  }

  return (
    <Page>
      <PageHeader withTabs={false}>
        <PageTitle title="Time Tracking - All Staff">
          <Button type="primary" onClick={handleTrackMyTimeClick}>
            Track My Time
          </Button>
        </PageTitle>
      </PageHeader>
      <PageContent>
        <p>
          Only active users with a Technician or Admin role can appear in the
          time tracking list and are able to log time. Go to “View Details” to
          Approve Timesheets.
        </p>
        {isLoading && <Loading />}
        {data && <StaffTable data={data.docs ?? []} />}
      </PageContent>
    </Page>
  );
};

export default Index;
